import type { CurrentAccount } from '../../api/types/reports';
import type { BillingInformation } from '../../api/types/billing';

/**
 * `BillingInformation`'ı legacy `CreateBillingInformationRequest`'teki 3 dallı mantığın
 * birebir karşılığıyla kurar (uçuş akışıyla aynı — `AirPassengerForm` de bunu kullanır):
 * cari hesap seçiliyse onun vergi no'suyla kurumsal fatura; değilse elle girilen T.C./
 * Vergi No ile bireysel fatura; ikisi de yoksa legacy fallback (`ifCompany: true`, boş
 * `taxNo`). `address`/`taxOffice` legacy'deki gibi sabit "B" — backend boş olmamasını
 * istiyor, gerçek metin beklemiyor.
 */
export function buildBillingInformation(
  currentAccount: CurrentAccount | null | undefined,
  billingName: string,
  identityOrTaxNo: string | undefined
): BillingInformation {
  const base = {
    billingName,
    address: 'B',
    taxOffice: 'B',
    autoBill: false,
    serviceFee: 0,
  };
  const currentTaxNo = currentAccount?.taxNumber;
  if (currentTaxNo) {
    return { ...base, ifCompany: true, ifCurrentCodeSet: true, taxNo: currentTaxNo };
  }
  if (identityOrTaxNo) {
    return { ...base, ifCompany: false, ifCurrentCodeSet: false, taxNo: identityOrTaxNo };
  }
  return { ...base, ifCompany: true, ifCurrentCodeSet: false, taxNo: '' };
}

/**
 * Kurumsal "Onaya Gönder" akışında seçilen cari firmanın (`CorporateEmployee.gsaList`)
 * `currentCode`'undan `BillingInformation` kurar. Legacy `Flight/Allocated` bu değeri
 * `#TaxNumberViaCurrent` (name=`TaxNumber`) alanına yazar; `CreateBillingInformationRequest`
 * de dolu `TaxNumber` → `{ IfCompany: true, IfCurrentCodeSet: true, TaxNo: <currentCode> }`
 * üretir. Yani cari kodu `taxNo` alanında `ifCurrentCodeSet: true` ile taşınır.
 */
export function buildBillingInformationFromCurrentCode(
  currentCode: string,
  billingName: string
): BillingInformation {
  return {
    billingName,
    address: 'B',
    taxOffice: 'B',
    autoBill: false,
    serviceFee: 0,
    ifCompany: true,
    ifCurrentCodeSet: true,
    taxNo: currentCode,
  };
}

export function formatAccountBalance(limit?: number): string {
  if (limit === undefined || limit === null) return '—';
  return `${limit.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
}
